export default "/bunjo/images/search/map/pin-home-active.svg?e19846699371209e3acabd00bb3ec32d";